import React, {Suspense, useContext} from "react";
import "./themes/kendo-theme-custom.scss";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Roles from "./pages/private/roles/Roles";
import MainLayout from "./layouts/main/MainLayout";
import Inspections from "./pages/private/inspections/Inspections";
import Forms from "./pages/private/forms/Forms";
import MyInspections from "./pages/private/my-inspections/MyInspections";
import Home from "./pages/private/home/Home";
import RequireAuth from "./auth/RequireAuth";
import Access from "./pages/access/Access";
import "./themes/variables.css";
import Help from "./pages/private/help/Help";
import QrReader from "./pages/private/qr-reader/QrReader";
import Password from "./pages/private/password/Password";
import AllInspections from "./pages/admin/all-inspections/AllInspections";
import {StoreContext} from "./store/StoreContext";
import Preview from "./pages/private/preview/Preview";
import VerifyAdmin from "./auth/VerifyAdmin";
import Index from "./pages/private/Index/Index";
import Reunion from "./pages/private/inspections/Reunion";
import Incidentes from "./pages/private/inspections/Incidentes";
import ErrorBoundary from "./components/error-boundary/ErrorBoundary";

// Lazy load admin pages — solo se cargan si el usuario es admin
const AdminHome = React.lazy(() => import("./pages/admin/home/Home"));
const GeneralParameters = React.lazy(() => import("./pages/admin/general-parameters/GeneralParameters"));
const AllFormsMultiple = React.lazy(() => import("./pages/admin/all-forms-multiple/AllFormsMultiple"));
const ParametersByForms = React.lazy(() => import("./pages/admin/parameters-by-forms/ParametersByForms"));
const QuestionsByForms = React.lazy(() => import("./pages/admin/questions-by-form/QuestionsByForm"));
const AllForms = React.lazy(() => import("./pages/admin/all-forms/AllForms"));
const DeletedInspections = React.lazy(() => import("./pages/admin/deleted-inspections/DeletedInspections"));

function App() {
  const {session} = useContext(StoreContext);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Access />} />
        <Route
          path="/cermaq/"
          element={
            <RequireAuth>
              <MainLayout />
            </RequireAuth>
          }
        >
          <Route path="" element={<Home />} />
          <Route path="password" element={<Password />} />
          <Route path="roles" element={<Roles />} />
          <Route path="roles/:rol" element={<Inspections />} />
          <Route path="roles/:rol/forms/:templateId" element={<ErrorBoundary><Forms /></ErrorBoundary>} />
          <Route path="Reunion/:rol/forms/:templateId" element={<ErrorBoundary><Forms /></ErrorBoundary>} />
           <Route path="Incidentes/:rol/forms/:templateId" element={<ErrorBoundary><Forms /></ErrorBoundary>} />
          {/* Edit */}
          <Route
            path="roles/:rol/forms/:templateId/:formId"
            element={<ErrorBoundary><Forms /></ErrorBoundary>}
          />
          <Route path="roles/forms/:templateId/:formId" element={<ErrorBoundary><Forms /></ErrorBoundary>} />
          {/* Preview */}
          <Route
            path="roles/:rol/forms/preview/:templateId/:formId"
            element={<Preview />}
          />
          <Route
            path="roles/forms/preview/:templateId/:formId"
            element={<Preview />}
          />

          <Route path="my-inspections/:rol" element={<MyInspections />} />
          <Route path="my-inspections" element={<MyInspections />} />
          <Route path="all-inspections" element={<AllInspections />} />
          <Route path="Index" element={<Index />} />
          <Route path="help" element={<Help />} />
          <Route path="qr-reader" element={<QrReader />} />
          <Route path="Reunion/:rol" element={<Reunion />} />
          <Route path="Reunion" element={<Reunion />} />
          <Route path="Incidentes/:rol" element={<Incidentes />} />
          <Route path="Incidentes" element={<Incidentes />} />
          <Route path="admin/" element={<VerifyAdmin session={session} />}>
            <Route path="" element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><AdminHome /></Suspense>} />
            <Route path="general-parameters" element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><GeneralParameters /></Suspense>} />
            <Route path="parameters-by-forms" element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><AllFormsMultiple /></Suspense>} />
            <Route
              path="parameters-by-forms/:templateIds"
              element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><ParametersByForms /></Suspense>}
            />
            <Route
              path="questions-by-form"
              element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><AllForms /></Suspense>}
            />
            <Route
              path="questions-by-form/:templateId"
              element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><QuestionsByForms /></Suspense>}
            />
            <Route path="deleted-inspections" element={<Suspense fallback={<div className="text-center py-4">Cargando...</div>}><DeletedInspections /></Suspense>} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
